module.exports = __webpack_public_path__ + "img/smgl.f63357b7.png";